export default "__VITE_ASSET__d71c511b__"